module.exports = "https://trybtryb-legacy.web.app/img/imposter-syndrome-desktop.7014afa9.webp";